// Authoritative MotionX Studios Portfolio & Feature Film Credits (21 Videos + 3 Telugu Feature Films + Rudra)
export const SHOWREEL_URL = "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fshowreel-laptop-main.mp4?alt=media&token=7b873d08-dde6-4b51-9f6c-43d9c567054e";
export const SHOWREEL_MOBILE_URL = "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fshowreel-mobile-notext.mp4?alt=media&token=05e26325-79a0-4588-b06a-957785eb0280";
export const SHOWREEL_POSTER_URL = "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fshowreel-laptop-main-poster.jpg?alt=media&token=7b9205f2-0322-4655-bde4-9a169ee43b15";
export const SHOWREEL_MOBILE_POSTER_URL = "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fshowreel-mobile-notext-poster.jpg?alt=media&token=1ecfd974-3091-44be-bf3b-c32ef892b178";
export const RUDRA_PREVIEW_URL = 'https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/Rudra%20Preview.mp4?alt=media&token=3150b794-4c0a-4c4e-9d78-4b0cc9e6f01e';

export const PILLAR_CATEGORIES = [
  {
    "id": "brand_work",
    "label": "Brand Work & Micro-Dramas",
    "count": 9,
    "badge": "Client Productions",
    "summary": "Commissioned brand commercials (BKIC Insurance, Alcobrew BHRUM, Seef Properties, XPENG G9) and commissioned 9:16 micro-drama series for DramaBox & Dashverse."
  },
  {
    "id": "ai_ugc",
    "label": "AI UGC & Product Ads",
    "count": 6,
    "badge": "D2C & Performance",
    "summary": "High-converting AI UGC creator ads and photoreal D2C product commercials — Vendoz Bridal Sneakers, Zoom Shoes, MHPU Handbags, Fine Jewellery & Fintech."
  },
  {
    "id": "spec_ads",
    "label": "Spec Commercials (100% AI)",
    "count": 6,
    "badge": "100% AI-Native",
    "summary": "Concept-to-master commercials generated 100% with AI — Sony, Haute Couture Fashion, AI Bhi Chahiye, Artisan Pizzeria, Fevi Stick, and Zeddy."
  },
  {
    "id": "originals",
    "label": "MotionX Originals & Music Videos",
    "count": 6,
    "badge": "MotionX Original IP",
    "summary": "Highlighted Flagship Original \"Ashes of Fire\", mythological epic \"Jatayu\", arthouse shorts \"Flamingos\" & \"Mental\", and official music videos \"Aasmaan\" & \"Run\"."
  },
  {
    "id": "all",
    "label": "All Video Work",
    "count": 27,
    "badge": "Complete Catalog",
    "summary": "Every commercial, AI UGC spot, commissioned micro-drama, spec film, music video, and original production (27 films)."
  }
];

export const TELUGU_FEATURE_FILMS = [
  {
    "slug": "cult-vishwak-sen",
    "title": "#CULT",
    "star": "Vishwak Sen",
    "director": "Vishwak Sen",
    "banner": "Tarak Cinemas \u00b7 Sandeep Kakarala",
    "genre": "Slasher Action Thriller \u00b7 Pan-World Release",
    "role": "Hybrid AI VFX & Post-Production Pipeline",
    "description": "Billed as India\u2019s first slasher action thriller written, directed by, and starring Mass Ka Das Vishwak Sen with music by Ravi Basrur. MotionX delivered hybrid AI VFX shots, environment extensions, and high-resolution plate enhancements.",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fmovie-cult.jpg?alt=media&token=7835e276-158e-40f5-aa38-5b994f6be485",
    "year": "2026"
  },
  {
    "slug": "honey-naveen-chandra",
    "title": "HONEY",
    "star": "Naveen Chandra, Divya Pillai & Divi",
    "director": "Karuna Kumar (Palasa 1978 fame)",
    "banner": "Theatrical Feature Film",
    "genre": "Dark Psychological & Occult Thriller",
    "role": "Hybrid AI VFX & Atmospheric Synthesis",
    "description": "Dark psychological horror-thriller starring Naveen Chandra and directed by acclaimed filmmaker Karuna Kumar. MotionX executed hybrid AI VFX sequences and supernatural environment compositing.",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fmovie-honey.jpg?alt=media&token=93dc0706-6af7-42d4-8fe3-244e53e6533d",
    "year": "2026"
  },
  {
    "slug": "manodu-goat-sudigali-sudheer",
    "title": "MANODU G.O.A.T",
    "star": "Sudigali Sudheer & Divya Bharathi",
    "director": "Naresh Kuppili (Paagal fame)",
    "banner": "Lucky Media & Maharaja Creations",
    "genre": "Mass Action & Commercial Entertainer",
    "role": "Hybrid AI VFX & Crowd/Set Extension",
    "description": "High-energy mass entertainer starring Sudigali Sudheer and Divya Bharathi with music by Leon James. MotionX provided hybrid AI VFX, set extensions, and plate transformations.",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fmovie-goat.jpg?alt=media&token=5de8e874-d99c-4d29-abfe-5a3e2e9a2dbf",
    "year": "2026"
  }
];

export const PORTFOLIO_ITEMS = [
  {
    "slug": "bkic-ramadan",
    "title": "BKIC Insurance — Ramadan Campaign",
    "client": "BKIC (Bahrain Kuwait Insurance)",
    "subtitle": "Brand Commercial · Bahrain",
    "category": "brand_work",
    "subType": "Brand Commercial",
    "productionMode": "Hybrid Live-Action + AI VFX",
    "tags": [
      "Client: BKIC",
      "Hybrid VFX",
      "Broadcast TV"
    ],
    "description": "Broadcast Ramadan campaign produced for Bahrain Kuwait Insurance Company (BKIC). Combines live-action family performances with AI environment extension and broadcast color finishing.",
    "featured": true,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fbkic-ramadan.mp4?alt=media&token=43cb0639-8dcf-4050-b78a-840855235ff4",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fbkic-ramadan-poster.jpg?alt=media&token=8ca1ea8e-b180-4fbb-a49d-ba6319954c98",
    "aspect": "16:9",
    "width": 1280,
    "height": 720,
    "durationSec": 45.0,
    "isoDuration": "PT00M45S"
  },
  {
    "slug": "bhrum",
    "title": "BHRUM — Crafted Rum Launch Spot",
    "client": "Alcobrew Distilleries",
    "subtitle": "Brand Commercial · Alcobrew (BHRUM)",
    "category": "brand_work",
    "subType": "Brand Commercial",
    "productionMode": "100% AI + Hybrid Finishing",
    "tags": [
      "Client: Alcobrew",
      "Brand: BHRUM",
      "9:16 Commercial"
    ],
    "description": "High-energy commercial campaign for Alcobrew’s BHRUM bottle launch, set in a warm rooftop lounge and engineered for high-retention social and digital broadcast.",
    "featured": true,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fbhrum.mp4?alt=media&token=91143282-ce97-4789-97dd-94c1fb6462fa",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fbhrum-poster.jpg?alt=media&token=b5e2c540-7a15-4cea-b369-7767feb301d6",
    "aspect": "9:16",
    "width": 1920,
    "height": 3414,
    "durationSec": 34.2,
    "isoDuration": "PT00M34S"
  },
  {
    "slug": "seef-real-estate",
    "title": "Seef Properties — Waterfront Living",
    "client": "Seef Properties",
    "subtitle": "Brand Film · Real Estate (Bahrain)",
    "category": "brand_work",
    "subType": "Brand Commercial",
    "productionMode": "Hybrid Live-Action + AI VFX",
    "tags": [
      "Client: Seef Properties",
      "Environment VFX",
      "4K Master"
    ],
    "description": "Architectural and lifestyle brand film for Seef Properties in Bahrain, blending live-action capture with expansive AI waterfront environment extensions.",
    "featured": true,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fseef-real-estate.mp4?alt=media&token=076f2bad-f222-4b06-acfc-f0a0356ecc20",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fseef-real-estate-poster.jpg?alt=media&token=902c2b7e-880a-487f-93e6-4d9ef4f20ff4",
    "aspect": "16:9",
    "width": 1280,
    "height": 720,
    "durationSec": 48.0,
    "isoDuration": "PT00M48S"
  },
  {
    "slug": "xpeng-g9",
    "title": "XPENG G9 — Desert & Skyline Odyssey",
    "client": "XPENG Motors (Middle East)",
    "subtitle": "Automotive Brand Commercial",
    "category": "brand_work",
    "subType": "Brand Commercial",
    "productionMode": "100% AI-Native Production",
    "tags": [
      "Automotive Commercial",
      "Blue-Hour VFX",
      "100% AI"
    ],
    "description": "Luxury electric SUV commercial pairing a masked oud virtuoso at blue hour against an illuminated Gulf skyline with dynamic automotive cinematography.",
    "featured": true,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fxpeng-g9.mp4?alt=media&token=924475f9-d7f8-4ddd-9f76-37755d23598d",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fxpeng-g9-poster.jpg?alt=media&token=3dca323a-bdf0-456f-b6a9-b4defe73cfc0",
    "aspect": "16:9",
    "width": 1920,
    "height": 1080,
    "durationSec": 43.0,
    "isoDuration": "PT00M43S"
  },
  {
    "slug": "cq-bookmark",
    "title": "Bookmark (C&Q)",
    "client": "C&Q · Runway Big Ad Contest",
    "subtitle": "Brand Commercial · Award Finalist",
    "category": "brand_work",
    "subType": "Brand Commercial",
    "productionMode": "100% AI-Native Production",
    "tags": [
      "Brand Film",
      "Runway Finalist",
      "100% AI"
    ],
    "description": "Acclaimed commercial spot produced for C&Q and the Runway Big Ad Contest, demonstrating rapid concept-to-broadcast execution.",
    "featured": false,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fcq-bookmark.mp4?alt=media&token=5f77d90e-54a7-4fdc-b05c-2bf14c7c7fb3",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fcq-bookmark-poster.jpg?alt=media&token=fed0a49e-2f2e-45cc-881f-f334b42f9ff1",
    "aspect": "16:9",
    "width": 1280,
    "height": 720,
    "durationSec": 48.0,
    "isoDuration": "PT00M48S"
  },
  {
    "slug": "anna",
    "title": "Anna — Shadows of Deception",
    "client": "DramaBox",
    "subtitle": "Client Micro-Drama · DramaBox",
    "category": "brand_work",
    "subType": "Micro-Drama (Client Work)",
    "productionMode": "100% AI-Native Episodic",
    "tags": [
      "Client: DramaBox",
      "9:16 Micro-Drama",
      "1080p Upscaled"
    ],
    "description": "Commissioned 9:16 vertical neo-noir suspense micro-drama produced for DramaBox, finished through our custom ComfyUI 1080p upscaling pipeline.",
    "featured": true,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fanna.mp4?alt=media&token=bc20e7e4-f7f4-47be-8d61-cf8414993743",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fanna-poster.jpg?alt=media&token=2495a632-50ac-4f41-8fcc-e3eaefc1e733",
    "aspect": "9:16",
    "width": 1080,
    "height": 1920,
    "durationSec": 48.0,
    "isoDuration": "PT00M48S"
  },
  {
    "slug": "drama-box-action",
    "title": "Iron Horizon — Siege Protocol",
    "client": "DramaBox",
    "subtitle": "Client Action Micro-Drama · DramaBox",
    "category": "brand_work",
    "subType": "Micro-Drama (Client Work)",
    "productionMode": "100% AI-Native Episodic",
    "tags": [
      "Client: DramaBox",
      "9:16 Action Series",
      "Battlefield VFX"
    ],
    "description": "Explosive 9:16 vertical action micro-drama commissioned for DramaBox, featuring large-scale battlefield VFX, tactical combat, and rapid episodic turnaround.",
    "featured": true,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fdrama-box-action.mp4?alt=media&token=60910f85-1195-4f87-8e9d-c6ef088a6256",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fdrama-box-action-poster.jpg?alt=media&token=02880049-0948-43c6-be41-9fe245f7e772",
    "aspect": "9:16",
    "width": 1280,
    "height": 2276,
    "durationSec": 48.0,
    "isoDuration": "PT00M48S"
  },
  {
    "slug": "episode-09",
    "title": "Chronicles — Episode 09",
    "client": "Dashverse",
    "subtitle": "Client Micro-Drama Series · Dashverse",
    "category": "brand_work",
    "subType": "Micro-Drama (Client Work)",
    "productionMode": "100% AI-Native Episodic",
    "tags": [
      "Client: Dashverse",
      "9:16 Episodic Drama",
      "Character Consistency"
    ],
    "description": "Commissioned vertical micro-drama episode produced for Dashverse, showcasing multi-scene character consistency, expressive dialogue, and rapid serialized delivery.",
    "featured": false,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fepisode-09.mp4?alt=media&token=383523a7-e17c-492e-afa2-2cfdba223018",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fepisode-09-poster.jpg?alt=media&token=35425328-969f-4f27-86a6-0b27054ed8d2",
    "aspect": "9:16",
    "width": 1080,
    "height": 1920,
    "durationSec": 48.0,
    "isoDuration": "PT00M48S"
  },
  {
    "slug": "episode-11",
    "title": "Chronicles — Episode 11",
    "client": "Dashverse",
    "subtitle": "Client Micro-Drama Series · Dashverse",
    "category": "brand_work",
    "subType": "Micro-Drama (Client Work)",
    "productionMode": "100% AI-Native Episodic",
    "tags": [
      "Client: Dashverse",
      "9:16 Episodic Drama",
      "Serialized Production"
    ],
    "description": "Follow-up commissioned episode for Dashverse’s vertical drama series, delivered at 5x traditional episodic production speed.",
    "featured": false,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fepisode-11.mp4?alt=media&token=2a228f1f-722d-4822-93b1-979e81842bd9",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fepisode-11-poster.jpg?alt=media&token=d13f1344-77c1-470e-b78c-720b79baea10",
    "aspect": "9:16",
    "width": 1080,
    "height": 1920,
    "durationSec": 48.0,
    "isoDuration": "PT00M48S"
  },
  {
    "slug": "sony-ad",
    "title": "Sony — Prehistoric Worlds & Aurora",
    "client": "Sony (Spec Commercial)",
    "subtitle": "100% AI Spec Ad · Electronics",
    "category": "spec_ads",
    "subType": "Spec Commercial",
    "productionMode": "100% AI-Native Production",
    "tags": [
      "Spec Commercial",
      "100% AI",
      "Creature & Aurora Synthesis"
    ],
    "description": "100% AI-generated electronics spec commercial transporting viewers to an Arctic tundra beneath vivid aurora borealis with photoreal wooly mammoths.",
    "featured": true,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fsony-ad.mp4?alt=media&token=b1026886-b09e-4cfb-8fe9-a4010561cfb7",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fsony-ad-poster.jpg?alt=media&token=b0aec6db-7358-47cd-9d6d-2bc1c9d7f945",
    "aspect": "16:9",
    "width": 1280,
    "height": 720,
    "durationSec": 45.0,
    "isoDuration": "PT00M45S"
  },
  {
    "slug": "fashion-ad",
    "title": "Haute Couture — Sculptural Avant-Garde",
    "client": "Luxury Fashion Spec",
    "subtitle": "100% AI Spec Campaign · Fashion",
    "category": "spec_ads",
    "subType": "Spec Commercial",
    "productionMode": "100% AI-Native Production",
    "tags": [
      "Spec Commercial",
      "100% AI",
      "Luxury Editorial"
    ],
    "description": "Architectural high-fashion spec campaign featuring intricate pleated couture silhouettes, futuristic brutalist environments, and editorial camera movement.",
    "featured": true,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Ffashion-ad.mp4?alt=media&token=7c999218-c8c4-4855-bf60-c2329c4b472b",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Ffashion-ad-poster.jpg?alt=media&token=59ec0218-3834-4568-888e-c9469ef23c1d",
    "aspect": "16:9",
    "width": 1920,
    "height": 1080,
    "durationSec": 75.0,
    "isoDuration": "PT01M15S"
  },
  {
    "slug": "ai-bhi-chayiye",
    "title": "AI Bhi Chahiye — Tech Innovation Spot",
    "client": "Consumer Tech Spec",
    "subtitle": "AI Spec Commercial · Consumer Tech",
    "category": "spec_ads",
    "subType": "Spec Commercial",
    "productionMode": "100% AI-Native Production",
    "tags": [
      "Spec Commercial",
      "Quirky Storytelling",
      "Holographic UI"
    ],
    "description": "High-character theatrical spec commercial pairing an eccentric inventor and lab assistant with holographic x-ray displays and comedic timing.",
    "featured": false,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fai-bhi-chayiye.mp4?alt=media&token=2cfd048e-3be8-40d2-ae72-a4e12a20c45c",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fai-bhi-chayiye-poster.jpg?alt=media&token=91db9496-d2e7-474b-b85f-a02b5dabc1d5",
    "aspect": "16:9",
    "width": 1920,
    "height": 1080,
    "durationSec": 47.0,
    "isoDuration": "PT00M47S"
  },
  {
    "slug": "pizza-ad",
    "title": "Artisan Pizzeria — Slice of Life",
    "client": "Food & Beverage Spec",
    "subtitle": "100% AI Spec Ad · Food & Beverage",
    "category": "spec_ads",
    "subType": "Spec Commercial",
    "productionMode": "100% AI-Native Production",
    "tags": [
      "Spec Commercial",
      "100% AI",
      "Tabletop & Crowd Cinema"
    ],
    "description": "Warm, kinetic food and lifestyle spec commercial capturing the energy, craft, and camaraderie of a packed neighborhood pizzeria.",
    "featured": false,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fpizza-ad.mp4?alt=media&token=64911b2c-bca7-4410-92a3-1279bfc4c050",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fpizza-ad-poster.jpg?alt=media&token=a60c7b50-453c-4cfb-8f3d-efbeb82a8b34",
    "aspect": "16:9",
    "width": 1920,
    "height": 1080,
    "durationSec": 47.4,
    "isoDuration": "PT00M47S"
  },
  {
    "slug": "fevi-twitch",
    "title": "Fevi Stick — Skyscraper Climber",
    "client": "FMCG Spec",
    "subtitle": "100% AI Spec Ad · Action Comedy",
    "category": "spec_ads",
    "subType": "Spec Commercial",
    "productionMode": "100% AI-Native Production",
    "tags": [
      "Spec Commercial",
      "100% AI",
      "Action Stunt Synthesis"
    ],
    "description": "Gravity-defying comedy-action spec commercial featuring vertical skyscraper scaling and dynamic wind physics.",
    "featured": false,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Ffevi-twitch.mp4?alt=media&token=8e3f074f-2ed4-448c-b773-c0b5f0541150",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Ffevi-twitch-poster.jpg?alt=media&token=879ecdf7-4f1f-44ab-b50f-40df6355b0a1",
    "aspect": "16:9",
    "width": 1920,
    "height": 810,
    "durationSec": 31.4,
    "isoDuration": "PT00M31S"
  },
  {
    "slug": "zeddy",
    "title": "Zeddy — Neon Noir Spot",
    "client": "Lifestyle Spec",
    "subtitle": "AI Spec Commercial · Youth & Lifestyle",
    "category": "spec_ads",
    "subType": "Spec Commercial",
    "productionMode": "100% AI + Stylized Relighting",
    "tags": [
      "Spec Commercial",
      "Neon Noir Grading",
      "Stylized Relighting"
    ],
    "description": "Moody crimson-and-emerald spec commercial demonstrating stylized noir lighting and atmospheric set synthesis.",
    "featured": false,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fzeddy.mp4?alt=media&token=1b74f288-12e9-42bd-ab37-81252dddbb93",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fzeddy-poster.jpg?alt=media&token=01db94c2-a87b-4ad6-8a47-121f38826f3b",
    "aspect": "16:9",
    "width": 1280,
    "height": 720,
    "durationSec": 35.5,
    "isoDuration": "PT00M36S"
  },
  {
    "slug": "ashes-of-fire",
    "title": "Ashes of Fire",
    "client": "MotionX Original IP",
    "subtitle": "★ Featured MotionX Original · Action Thriller",
    "category": "originals",
    "subType": "Flagship Original",
    "productionMode": "100% AI-Native Cinema",
    "tags": [
      "★ Highlighted Original",
      "2.39:1 Anamorphic",
      "Action Thriller"
    ],
    "description": "Our flagship nocturnal action-thriller Original. Showcases hyper-realistic rain-slicked automotive interiors, pyrotechnic action synthesis, and tense dramatic storytelling.",
    "featured": true,
    "highlight": true,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fashes-of-fire.mp4?alt=media&token=7a2b44f9-4ba0-4a1f-b8b8-9716afe892ee",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fashes-of-fire-poster.jpg?alt=media&token=2e56e03a-2cb1-4e05-84d9-0c2e4702a486",
    "aspect": "16:9",
    "width": 1280,
    "height": 548,
    "durationSec": 48.0,
    "isoDuration": "PT00M48S"
  },
  {
    "slug": "jatayu",
    "title": "Jatayu — Mythological Epic",
    "client": "MotionX Original IP",
    "subtitle": "MotionX Original · Mythological Action",
    "category": "originals",
    "subType": "Original Film",
    "productionMode": "100% AI-Native Cinema",
    "tags": [
      "MotionX Original",
      "Mythological Epic",
      "2.39:1 Scope"
    ],
    "description": "Sweeping mythological action original reimagining the legend of Jatayu with theatrical 2.39:1 widescreen framing, divine skies, and epic scale.",
    "featured": true,
    "highlight": false,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fjatayu.mp4?alt=media&token=76ed2bce-7c88-4386-94c3-ca4af897be2b",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fjatayu-poster.jpg?alt=media&token=fba9a934-bf68-4544-856f-b55c7b58db12",
    "aspect": "16:9",
    "width": 1280,
    "height": 548,
    "durationSec": 48.0,
    "isoDuration": "PT00M48S"
  },
  {
    "slug": "flamingos",
    "title": "Flamingos",
    "client": "MotionX Original IP",
    "subtitle": "MotionX Original · Surreal Arthouse Short",
    "category": "originals",
    "subType": "Original Film",
    "productionMode": "100% AI-Native Cinema",
    "tags": [
      "MotionX Original",
      "Arthouse Cinema",
      "Surreal Visuals"
    ],
    "description": "A poetic, dreamlike visual piece juxtaposing human stillness with thousands of flamingos across a mirror-like salt flat.",
    "watchUrl": "https://youtu.be/__sb8b64Chs",
    "featured": true,
    "highlight": false,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fflamingos.mp4?alt=media&token=70d17708-0da6-4ed8-ac55-ed8c59d7cca7",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fflamingos-poster.jpg?alt=media&token=7eb6bda6-08af-426c-9c81-7ccfc9c56d99",
    "aspect": "16:9",
    "width": 1280,
    "height": 720,
    "durationSec": 48.0,
    "isoDuration": "PT00M48S"
  },
  {
    "slug": "mental",
    "title": "Mental",
    "client": "MotionX Original IP",
    "subtitle": "MotionX Original · Psychological Short",
    "category": "originals",
    "subType": "Original Film",
    "productionMode": "100% AI-Native Cinema",
    "tags": [
      "MotionX Original",
      "Psychological Cinema",
      "2.39:1 Scope"
    ],
    "description": "Avant-garde psychological short using surreal overhead camera choreography, underwater light caustics, and symbolic visual storytelling.",
    "featured": true,
    "highlight": false,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fmental.mp4?alt=media&token=1c336b7d-4544-4bd8-8205-70ddcf0cb0ae",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fmental-poster.jpg?alt=media&token=3afc16bb-4772-4e91-8afb-08573fff9429",
    "aspect": "16:9",
    "width": 1280,
    "height": 548,
    "durationSec": 48.0,
    "isoDuration": "PT00M48S"
  },
  {
    "slug": "aasmaan-mv",
    "title": "Aasmaan — Official Music Video",
    "client": "MotionX Originals",
    "subtitle": "Official AI Music Video",
    "category": "originals",
    "subType": "Music Video",
    "productionMode": "100% AI & Hybrid Visuals",
    "tags": [
      "Official Music Video",
      "Dreamlike Transitions",
      "4K Master"
    ],
    "description": "Soulful narrative music video blending emotive performance visuals with poetic skyward metaphors and beat-synced AI transitions.",
    "featured": true,
    "highlight": false,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Faasmaan-mv.mp4?alt=media&token=4d6de435-9bc9-4c3d-89d9-efb380048249",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Faasmaan-mv-poster.jpg?alt=media&token=0a1ef97f-f992-45ad-82f3-7bdef0888be4",
    "aspect": "16:9",
    "width": 1280,
    "height": 720,
    "durationSec": 48.0,
    "isoDuration": "PT00M48S"
  },
  {
    "slug": "run-mv",
    "title": "Run — Official Music Video",
    "client": "MotionX Originals",
    "subtitle": "Official Dark-Pop AI Music Video",
    "category": "originals",
    "subType": "Music Video",
    "productionMode": "100% AI-Native Music Video",
    "tags": [
      "Official Music Video",
      "Chiaroscuro Lighting",
      "Visual Album"
    ],
    "description": "Atmospheric dark-pop music video featuring moody silhouette lighting, surreal architectural corridors, and rhythmic AI visual synthesis.",
    "featured": true,
    "highlight": false,
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Frun-mv.mp4?alt=media&token=905e25e3-c069-44a5-b00c-f1a3f814c021",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Frun-mv-poster.jpg?alt=media&token=a9792f80-eeca-46fd-9531-84ad72f093b6",
    "aspect": "16:9",
    "width": 1280,
    "height": 720,
    "durationSec": 48.0,
    "isoDuration": "PT00M48S"
  },
  {
    "slug": "ugc-bitcoin",
    "title": "Fintech & Crypto Creator Spot",
    "subtitle": "AI UGC Spokesperson · Fintech (9:16)",
    "client": "Bitcoin / Fintech Campaign",
    "category": "ai_ugc",
    "subType": "AI UGC Creator Ad",
    "productionMode": "100% AI",
    "highlight": false,
    "aspect": "9:16",
    "width": 1080,
    "height": 1920,
    "durationSec": 38,
    "isoDuration": "PT38S",
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fugc-bitcoin.mp4?alt=media&token=2552363c-c431-4211-bb07-0f8913225f7b",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fugc-bitcoin-poster.jpg?alt=media&token=d6763973-5144-4886-bca6-a31c52e35b1f",
    "watchUrl": null,
    "description": "High-converting 9:16 AI UGC creator spokesperson ad set in a modern skyline office, engineered for TikTok, Instagram Reels, and paid performance acquisition.",
    "tags": [
      "100% AI",
      "AI UGC",
      "9:16 Vertical",
      "Fintech"
    ],
    "seoKeywords": [
      "AI UGC video production",
      "AI creator ad",
      "fintech UGC ad",
      "9:16 performance ad"
    ]
  },
  {
    "slug": "ugc-mhpu",
    "title": "MHPU — Designer Shoulder Bag",
    "subtitle": "AI Fashion & Product UGC · Accessories (9:16)",
    "client": "MHPU Accessories",
    "category": "ai_ugc",
    "subType": "AI Fashion UGC",
    "productionMode": "100% AI",
    "highlight": false,
    "aspect": "9:16",
    "width": 720,
    "height": 1280,
    "durationSec": 20,
    "isoDuration": "PT20S",
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fugc-mhpu.mp4?alt=media&token=e1acac35-640a-4754-b97e-a2e5288ce3c7",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fugc-mhpu-poster.jpg?alt=media&token=3a29ab8d-8403-45bd-803f-4f03f460f490",
    "watchUrl": null,
    "description": "Vertical D2C fashion and product reel pairing studio macro hardware shots with on-model styling for a two-tone pleated leather shoulder bag.",
    "tags": [
      "100% AI",
      "Fashion UGC",
      "9:16 Vertical",
      "D2C Product"
    ],
    "seoKeywords": [
      "AI fashion UGC",
      "D2C product video AI",
      "handbag commercial AI"
    ]
  },
  {
    "slug": "ugc-jewellery-necklace",
    "title": "Solitaire Diamond Pendant",
    "subtitle": "AI Luxury Product Reel · Fine Jewellery (9:16)",
    "client": "Luxury Jewellery D2C",
    "category": "ai_ugc",
    "subType": "AI Product Reel",
    "productionMode": "100% AI",
    "highlight": false,
    "aspect": "9:16",
    "width": 480,
    "height": 848,
    "durationSec": 12,
    "isoDuration": "PT12S",
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fugc-jewellery-necklace.mp4?alt=media&token=88c254b3-d997-4e0a-adf4-c22dd8e99523",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fugc-jewellery-necklace-poster.jpg?alt=media&token=04f01090-d0e7-4ecb-a6c0-eee0bd6979e3",
    "watchUrl": null,
    "description": "Macro 9:16 luxury jewellery reel showcasing realistic diamond fire, gold prong reflections, and creamy bokeh depth of field without physical macro rigs.",
    "tags": [
      "100% AI",
      "Fine Jewellery",
      "9:16 Vertical",
      "Macro Product"
    ],
    "seoKeywords": [
      "AI jewellery video",
      "diamond necklace AI ad",
      "luxury D2C video"
    ]
  },
  {
    "slug": "ugc-jewellery-ring",
    "title": "Pavé Diamond Ring Showcase",
    "subtitle": "AI Luxury Product Reel · Fine Jewellery (9:16)",
    "client": "Luxury Jewellery D2C",
    "category": "ai_ugc",
    "subType": "AI Product Reel",
    "productionMode": "100% AI",
    "highlight": false,
    "aspect": "9:16",
    "width": 480,
    "height": 848,
    "durationSec": 12,
    "isoDuration": "PT12S",
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fugc-jewellery-ring.mp4?alt=media&token=d03e28f8-5e9d-4d99-b9f8-fceaeaa233d2",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fugc-jewellery-ring-poster.jpg?alt=media&token=2023b407-b841-4a43-8882-92d6cf1b41b6",
    "watchUrl": null,
    "description": "High-conversion vertical product showcase of a stacked pavé diamond ring nestled in an emerald velvet presentation box with warm specular lighting.",
    "tags": [
      "100% AI",
      "Fine Jewellery",
      "9:16 Vertical",
      "Luxury D2C"
    ],
    "seoKeywords": [
      "AI ring commercial",
      "jewellery UGC video",
      "AI product cinematography"
    ]
  },
  {
    "slug": "ugc-vendoz-bridal-sneakers",
    "title": "Vendoz — Bridal Sneakers",
    "subtitle": "AI E-Commerce Product Ad · Bridal Footwear",
    "client": "Vendoz Footwear",
    "category": "ai_ugc",
    "subType": "AI E-Commerce Ad",
    "productionMode": "100% AI",
    "highlight": false,
    "aspect": "16:9",
    "width": 1080,
    "height": 608,
    "durationSec": 20,
    "isoDuration": "PT20S",
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fugc-vendoz-bridal-sneakers.mp4?alt=media&token=4948ad99-92cd-49a1-b5e9-fd5505f57715",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fugc-vendoz-bridal-sneakers-poster.jpg?alt=media&token=f0eb76f5-8abf-47b4-bdca-40c5cd2cfcf7",
    "watchUrl": null,
    "description": "E-commerce product spot for Vendoz showcasing maroon velvet bridal platform sneakers with intricate zardozi pearl embroidery and bridal lehenga styling.",
    "tags": [
      "100% AI",
      "Vendoz",
      "Footwear Ad",
      "E-Commerce"
    ],
    "seoKeywords": [
      "Vendoz bridal sneakers ad",
      "AI footwear commercial",
      "e-commerce product video AI"
    ]
  },
  {
    "slug": "ugc-zoom-shoes",
    "title": "Zoom Shoes — Tan Leather Boots",
    "subtitle": "AI E-Commerce Product Ad · Men's Footwear",
    "client": "Zoom Shoes",
    "category": "ai_ugc",
    "subType": "AI E-Commerce Ad",
    "productionMode": "100% AI",
    "highlight": false,
    "aspect": "16:9",
    "width": 1080,
    "height": 608,
    "durationSec": 20,
    "isoDuration": "PT20S",
    "videoUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fugc-zoom-shoes.mp4?alt=media&token=64975324-d4e4-489f-8533-1dfd1ac43753",
    "posterUrl": "https://firebasestorage.googleapis.com/v0/b/motionx-studio.firebasestorage.app/o/web-portfolio%2Fugc-zoom-shoes-poster.jpg?alt=media&token=b145e65c-0a19-4e7e-b0f1-4c2e4318cb88",
    "watchUrl": null,
    "description": "Crisp outdoor and on-foot product commercial for Zoom Shoes highlighting full-grain tan leather stitching, side-zip hardware, and street-level walking shots.",
    "tags": [
      "100% AI",
      "Zoom Shoes",
      "Footwear Ad",
      "E-Commerce"
    ],
    "seoKeywords": [
      "Zoom Shoes commercial",
      "AI shoe commercial",
      "D2C footwear video"
    ]
  }
];
